var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center align-items-center gap-4"},[_c('shield-check-icon',{attrs:{"size":"24","color":"#94A3B8"}}),_c('p',{staticClass:"small-regular gray-400"},[_vm._v(" Ambiente seguro ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }